import { Color } from '@coast/schemas';
import { isEmpty } from 'lodash';
import { Tag } from '@shared/components/blocks/lib/tags/tag';
import { API } from '@shared/types/api';

interface Props {
  tagOptions: API.AuditTagComponent['options'];
  tags: string[];
}

export function AuditTagList({ tagOptions, tags }: Readonly<Props>) {
  if (isEmpty(tags)) {
    return null;
  }
  const filteredOptions = tagOptions?.filter(tagOption => tags?.includes(tagOption.value));

  return (
    <>
      {filteredOptions?.map(option => {
        return (
          <Tag
            key={option.value}
            color={option.backgroundColor as Color}
            archived={!!option.archived}
            label={option.label}
          />
        );
      })}
    </>
  );
}
